var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7561 9.47012L20.3461 8.06012L16.0961 3.81012L14.6861 2.40012C14.3961 2.11012 13.9161 2.11012 13.6261 2.40012C13.3361 2.69012 13.3361 3.17012 13.6261 3.46012L14.5061 4.34012L11.0361 7.81012C9.36608 7.69012 7.74608 8.27012 6.54608 9.47012L5.83608 10.1801C5.54608 10.4701 5.54608 10.9501 5.83608 11.2401L8.84608 14.2501L3.01608 20.0801C2.72608 20.3701 2.72608 20.8501 3.01608 21.1401C3.16608 21.2901 3.35608 21.3601 3.54608 21.3601C3.73608 21.3601 3.92608 21.2901 4.07608 21.1401L9.90608 15.3101L12.9161 18.3201C13.0561 18.4601 13.2461 18.5401 13.4461 18.5401C13.6461 18.5401 13.8361 18.4601 13.9761 18.3201L14.6861 17.6101C15.8861 16.4101 16.4761 14.7901 16.3461 13.1201L19.8161 9.65012L20.6961 10.5301C20.8461 10.6801 21.0361 10.7501 21.2261 10.7501C21.4161 10.7501 21.6061 10.6801 21.7561 10.5301C22.0461 10.2401 22.0461 9.76012 21.7561 9.47012Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFilled);
export default __webpack_public_path__ + "static/media/pin-filled.f0fa78623ee84a4a84a66eea7d76507b.svg";
export { ForwardRef as ReactComponent };